import axios from 'axios';

const applicationsService = {
	fetchAllApplications: () => axios.get(`api/v1/applications`),
	fetchApplication: id => axios.get(`api/v1/applications/${id}`),
	updateApplication: params => axios.put(`api/v1/applications`, params),
	deleteApplication: params => axios.delete(`api/v1/applications`, { data: params }),
	fetchAppOperations: id => axios.get(`api/v1/applications/${id}/operations`),
	fetchAppResources: id => axios.get(`api/v1/applications/${id}/resources`),
	createApplication: params => axios.post('/api/v1/applications', params)
};

export default applicationsService;
